<template>
  <div
    class="option-list__container"
    :class="['type--' + type, ( 'column--' + getNumberOfColumns(type).toString() )]"
  >
    <div
      v-if="options.length"
      class="option-list"
      :class="'type--' + type"
    >
      <buy-guide-option v-for="(option, optionIndex) in options"
        :key="option.Header"
        :optionIndex="optionIndex"
        :stepIndex="currentStepIndex"
        :option="option"
      >
      </buy-guide-option>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Option from '@/components/buy-guide/components/option/option.vue';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
          currentStepIndex: state => state.buyGuide.currentStepIndex,
          steps: state => state.buyGuide.steps,
          status: state => state.buyGuide.status,
          results: state => state.buyGuide.results
      }),
    },
    components: {
      'buy-guide-option': Option
    },
    methods: {
    }
})
export default class AreaOfUse extends Vue {
  @Prop() type;
  @Prop() options;
  @Prop() getNumberOfColumns;

  created() {
    // console.log('AreaOfUse created');
  }

  mounted() {
  }

}

</script>

<style>

</style>
